import React from "react";
import { Stack, Box, Typography } from "@mui/material";
import { StarBorder } from "@mui/icons-material";

export const ServiceContentOne = ({ translate }) => {
  return (
    <Stack spacing={2}>
      <Box>
        <Box sx={{ marginBottom: "30px" }}>
          <Box>
            <Typography variant="h5" gutterBottom>
              <b>{translate("serviceContentHead1")}</b>
            </Typography>
          </Box>
          <Box sx={{ marginBottom: "10px" }}>
            <Typography variant="body2" sx={{ textIndent: "50px" }}>
              {translate("serviceContentBody1")}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: { xs: 3, sm: 10 },
            }}
          >
            <StarBorder fontSize="small" />
            <Typography variant="body2" ml={2}>
              {translate("serviceContentBody2")}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: { xs: 3, sm: 10 },
            }}
          >
            <StarBorder fontSize="small" />
            <Typography variant="body2" ml={2}>
              {translate("serviceContentBody3")}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: { xs: 3, sm: 10 },
            }}
          >
            <StarBorder fontSize="small" />
            <Typography variant="body2" ml={2}>
              {translate("serviceContentBody4")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
};
